import { getActionTypeFn } from 'shared/state-utils'
export const FEATURE_NAME = 'Auth'
export const getActionType = getActionTypeFn(FEATURE_NAME)
